export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq4-Report-PDF-Pg1.f62be57a.png";